import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Summary from "./summary";
// import CustomerReg from "./CustomerReg";
import Layout from "./Layout";
// import KitchenOrder from "./kitchenDisplay/index"

export const router = createBrowserRouter([
  {
    path: "/:m_id",
    element: <Layout />,
    children: [
      {
        path: "menu",
        element: <App />,
      },
      {
        path: "menu/summary",
        element: <Summary />,
      },
    ],
  },
  {
    path: "/:table_number",
    element: <Layout />,
    children: [
      {
        path: "tablemenu",
        element: <App />,
      },
      {
        path: "tablemenu/summary",
        element: <Summary />,
      },
    ],
  },
  {
    path: "/:room_number",
    element: <Layout />,
    children: [
      {
        path: "roommenu",
        element: <App />,
      },
      {
        path: "roommenu/summary",
        element: <Summary />,
      },
    ],
  },
  {
    path: "/:m_id",
    element: <Layout />,
    children: [
      {
        path: "waiterscreen",
        element: <App />,
      },
      {
        path: "waiterscreen/summary",
        element: <Summary />,
      },
    ],
  },
]);
